var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5c-.56 0-1.014.454-1.014 1.014v7.347H7.264a1.014 1.014 0 0 0 0 2.027h7.347v7.348a1.013 1.013 0 1 0 2.027 0v-7.348h7.348a1.013 1.013 0 1 0 0-2.027h-7.348V6.014c0-.56-.453-1.014-1.013-1.014Z"
  })));
};
export default SvgPlus;